<template lang="html">
  <d-button class="buttons btn-accent" @click="openModal()">
    Aprovar orçamento
  </d-button>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _OPEN_MODAL_ } from '_modules/quotation/components/QuotationModel';

export default {
  name: 'quotation-button-approve',
  props: {
    quotation: {
      type: Object,
      default: null,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    openModal() {
      const type = 'approved_admin_quotation_modal';
      this.setToggle({ type, bool: true });
      Events.$emit(_OPEN_MODAL_, { quotation: this.quotation, type });
    },
  },
};
</script>
